function openTabInfo(evt, tabName) {
    var tabcontent1, tablinksInfo;
  
    const parent = evt.currentTarget.closest('.product-tabs-info');
    tabcontent1 = parent.getElementsByClassName("tabcontent-info");
    for (var i = 0; i < tabcontent1.length; i++) {
      tabcontent1[i].style.display = "none";
    }
  
    tablinksInfo = parent.getElementsByClassName("tablinks-info");
    for (var i = 0; i < tablinksInfo.length; i++) {
      tablinksInfo[i].classList.remove("active");
    }
  
    document.getElementById(tabName).style.display = "block";
    evt.currentTarget.classList.add("active");
}
